import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './PublicNavBar.css';

function PublicNavBar() {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="public-navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          BarkBacks
        </Link>

        <div className="navbar-links">
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link
            to="/for-businesses"
            className={`nav-link ${isActive('/for-businesses') ? 'active' : ''}`}
          >
            For Businesses
          </Link>
        </div>

        <div className="navbar-auth">
          <Link to="/app/login" className="btn btn-text">
            Customer Login
          </Link>
          <Link to="/business/login" className="btn btn-text">
            Business Login
          </Link>
          <Link to="/app/register" className="btn btn-primary-small">
            Get Started
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default PublicNavBar;
